interface Props {
    condition: boolean
    wrapper: (children) => React.ReactNode
    children: any
}

export const ConditionalWrapper = ({ condition, wrapper, children }: Props) => (condition ? wrapper(children) : children)
